import { Modal } from "../ui/modal/Modal"
import { ModalOk } from "../ui/modal/ModalOk"
import { ModalError } from "../ui/modal/ModalError"
import { msg, Msg } from "../ui/modal/utils"
import { useState } from "react"

import { api } from "../../services/api"
import { getCookie } from "../../helpers/cookies"
import { config } from "../../config"
import { rnd } from "../../helpers/utils"
import { sha256 } from "../../helpers/jwt"
import useFetch from "../../hooks/useFetch"
import { useQuery } from "../../hooks/useQuery"
import { useTranslation, Trans } from "react-i18next"

export const ModalEditarUsuario = ({ show, user_id, setUsers }) => {
  const roles = ["admin", "teacher"]

  const randomPassword = rnd(16),
    [pass, setPass] = useState(randomPassword)

  const [user, isPendingUser, errUser, setUser] = useFetch({
    url: `${config.apiUrl}/users/${user_id}`,
  })

  const { t } = useTranslation()

  const modalBody = () => {
    return (
      <>
        {isPendingUser && <Msg m={t(`ui.btns.loading`) + "..."} />}
        {errUser && <Msg m={t(`ui.msgs.something_went_wrong`)} />}
        {user && (
          <div className="p-3 pt-0" style={{ background: "hsl(0deg 0% 90%)" }}>
            <div className="form-group">
              <label className="form-label mt-4">
                {t(`admin.users.username`)}
              </label>
              <div className="input-group mb-3">
                <span className="input-group-text">@</span>
                <input
                  onChange={(e) =>
                    setUser({ ...user, username: e.target.value })
                  }
                  value={user.username}
                  className="form-control"
                  placeholder={t(`admin.users.placeholder_username`)}
                />
              </div>
              <small className="form-text text-muted">
                {t(`admin.users.no_spaces`)}
              </small>
            </div>

            <div className="form-group">
              <label className="form-label mt-4">
                {t(`admin.users.password`)}
              </label>
              <input
                onChange={(e) => setPass(e.target.value)}
                value={pass}
                type="password"
                className="form-control"
                placeholder={t(`admin.users.password`)}
              />
            </div>

            <div className="form-group">
              <label className="form-label mt-4">
                {t(`admin.users.user_rol`)}
              </label>
              <select
                defaultValue={user.role}
                className="form-select"
                onChange={(e) => setUser({ ...user, role: e.target.value })}>
                {roles.map((role, ix) => (
                  <option key={ix} value={role}>
                    {role}
                  </option>
                ))}
              </select>
            </div>
          </div>
        )}
      </>
    )
  }

  const updateUser = useQuery()
  const showRes = useState(false)

  const runQuery = async () => {
    showRes[1](true)

    // recolecto toda la data necesaria para el fetch
    const tkn = getCookie("jwt")
    const data = Object.assign({}, user)
    if (pass !== randomPassword) {
      const hashedPassword = sha256(pass)
      data.hashedPassword = hashedPassword
    }
    const { url, opt } = api.users.update({
      token: tkn,
      user_id: user.user_id,
      user: data,
    })

    // ejecuto
    updateUser.url.current = url
    updateUser.opt.current = opt
    updateUser.run({
      onOk: () => {
        setUsers((currents) =>
          currents.map((current) => {
            if (current.user_id !== user_id) return current

            return data
          })
        )
      },
    })
  }

  const modalFooter = () => {
    const handleCancelar = () => show[1](false)
    return (
      <>
        <button
          type="button"
          className="btn btn-danger"
          onClick={() => handleCancelar()}>
          {t(`ui.btns.cancel`)}
        </button>

        <button
          type="button"
          className="btn btn-primary"
          disabled={updateUser.isPending}
          onClick={() => runQuery()}>
          {updateUser.isPending
            ? t(`ui.btns.submiting`) + "..."
            : t(`ui.btns.save`)}
        </button>
      </>
    )
  }

  return (
    <>
      <Modal
        id="editar-usuario"
        show={show}
        header={<center>{t(`modals.modal_edit_user.header`)}</center>}
        body={modalBody()}
        footer={modalFooter()}
      />

      {/* modales para los resultados */}

      {updateUser.res && !updateUser.err && (
        <ModalOk
          show={[showRes[0], show[1]]}
          body={msg(
            <Trans
              i18nKey="modals.modal_edit_user.sucess_msg"
              values={{ user: updateUser.res.username }}
              components={{ i: <i /> }}
            />
          )}
        />
      )}

      {updateUser.res && updateUser.err && (
        <ModalError show={showRes} res={updateUser.res} />
      )}
    </>
  )
}
